import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AnalyticsService } from "@modules/core";
import { createDialogConfig, generateUpgradeUrl } from "@utils";

export type UpgradePromptDialogData = {
  limitType?: string;
  referrer?: string;
} | null;

export type UpgradePromptDialogResult = unknown;

@Component({
  selector: "app-upgrade-prompt-dialog",
  templateUrl: "./upgrade-prompt-dialog.component.html",
  styleUrls: ["./upgrade-prompt-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UpgradePromptDialogComponent {
  public upgradeUrl = generateUpgradeUrl({
    redirectPath: "/network",
  });

  public constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: UpgradePromptDialogData,
    private matDialogRef: MatDialogRef<
      UpgradePromptDialogData,
      UpgradePromptDialogResult
    >,
    private analyticsService: AnalyticsService
  ) {}

  public static openDialog(
    matDialog: MatDialog,
    data?: UpgradePromptDialogData
  ): MatDialogRef<UpgradePromptDialogComponent, UpgradePromptDialogResult> {
    const config = createDialogConfig<UpgradePromptDialogData>(data ?? null, {
      panelClasses: ["upgrade-prompt-dialog"],
      maxWidth: "400px",
    });
    config.autoFocus = "dialog";
    return matDialog.open<
      UpgradePromptDialogComponent,
      UpgradePromptDialogData,
      UpgradePromptDialogResult
    >(UpgradePromptDialogComponent, config);
  }

  public onViewPlans(): void {
    this.analyticsService
      .logEvent({
        eventType: "FreePlanLimitCtaClick",
        timestamp: new Date().toISOString(),
        limitType: this.dialogData?.limitType,
        referrer: this.dialogData?.referrer,
        ctaType: "ViewPlans",
      })
      .subscribe();
    window.open(this.upgradeUrl, "_blank");
    this.matDialogRef.close();
  }

  public onDismiss(): void {
    this.analyticsService
      .logEvent({
        eventType: "FreePlanLimitCtaClick",
        timestamp: new Date().toISOString(),
        limitType: this.dialogData?.limitType,
        referrer: this.dialogData?.referrer,
        ctaType: "Dismiss",
      })
      .subscribe();
    this.matDialogRef.close();
  }
}
